import React from 'react';

const GetStartedSection = () => {
  const scrollToHero = () => {
    document.getElementById('hero-section').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-gradient-to-tr from-[#264864] via-[#264864] to-[#35a89d] overflow-hidden font-sans py-20">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-48 h-48 bg-[#35a89d]/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-64 h-64 bg-[#264864]/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>
      <div className="container mx-auto px-4 text-center relative z-10">
        <h2 className="text-4xl font-bold text-white mb-4">Ready to Start Your Project?</h2>
        <p className="text-lg text-white/80 mb-8">
          Let's build something amazing together. Contact us to discuss your ideas and see how we can help you achieve your goals.
        </p>
        
        <button 
          onClick={scrollToHero}
          className="inline-block group relative overflow-hidden bg-gradient-to-br from-[#58afd1] to-[#4a9bc4] hover:from-[#4a9bc4] hover:to-[#264864] text-white font-medium px-8 py-3 text-sm transition-all duration-400 shadow-lg hover:shadow-xl rounded-lg"
        >
          <span className="relative z-10 flex items-center justify-center">
            Get Started
            <svg className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </span>
        </button>
      </div>
    </section>
  );
};

export default GetStartedSection;